/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bucket': {
    width: 13,
    height: 15,
    viewBox: '0 0 13 15',
    data: '<path pid="0" d="M12.129 1.903H9.226L8.396.742H4.25l-.83 1.161H.516v1.161H12.13v-1.16zM1.677 13.184c.018.84.71 1.506 1.55 1.493H9.42h-.001a1.526 1.526 0 001.549-1.493V4.226h-9.29v8.958z" _fill="#D71254" fill-rule="evenodd"/>'
  }
})
